<ng-container *transloco="let t">
<div class="d-flex">
    @for(count of displayCount; track count){
        <div [ngClass]="['me-3', 'competitor-count-badge', classMap.get(count) ?? '' ]">
                        <span class="text-uppercase">
                          {{ labelsMap.get(count) ? (t(labelsMap.get(count)!) | uppercase ) : ""}} : {{ competitorCount?.[count] ?? "-"}}
                        </span>
    </div>
    }
</div>
</ng-container>